import axios from "axios";

const url = process.env.REACT_APP_BASE_URL;
const key = process.env.REACT_APP_KEY;
const handlername = 'ai engineer';


const client = axios.create({
  baseURL: `${url}/salesNavigator`,
  headers: {
    "Content-Type": "application/json",
  },
  params: {
    handlername: handlername,
    key: key
  }
});

export const getData = async () => {
  try {
    const data = await client.get();
    return data;
  } catch (error) {
    console.log(error);
  }
};
